import styled from "styled-components";

export const CellContainerStyled = styled.div`
  display: flex;
  padding: 14px 16px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  color: #1b1b1b;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  line-height: 140%;
`;

export const CellButtonStyled = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  color: #3f7f7d;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 19.6px;
  word-wrap: break-word;
  width: max-content;

  &:hover {
    text-decoration: underline;
  }
`;

export const TableOptionsContainerStyled = styled.div`
  height: 100%;
  width: 14px;
`;

type HotJobButtonProps = {
  isHot: boolean;
};

export const HotJobButtonStyled = styled.button<HotJobButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 14px;
  opacity: ${(props) => (props.isHot ? 1 : 0.4)};
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
    background: #eef8f8;
  }
`;

export const HotJobBadgeStyled = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  margin-left: 6px;
  background: #e85a00;
  color: #ffffff;
  font-size: 10px;
  font-family: "Readex Pro", sans-serif;
  font-weight: 700;
  line-height: 14px;
  border-radius: 3px;
  letter-spacing: 0.04em;
  flex-shrink: 0;
`;
